// extracted by mini-css-extract-plugin
export default {"Csv":"UploadCsv_Csv__FR6Tf","Top":"UploadCsv_Top__oyTwx","Title":"UploadCsv_Title__sRgda","UploadText":"UploadCsv_UploadText__rHWc0","Blue":"UploadCsv_Blue__g+if9"};